// @ts-ignore
jQuery(document).ready(function ($) {
    //GENERAL LOGC FUNCTIONALITY//
    //video click functionality
    //video with iframe
    $(".click.vid_iframe").click(function () {
        if ($(this).hasClass("active")) {
        $(this).find("video")[0].pause();
        } else {
        var videoIframe = $(this).find("iframe");
        console.log(videoIframe);
        var videoSrc = videoIframe.attr("src");
        console.log(videoSrc);
        var symbol = $(this).find("iframe")[0].src.indexOf("?") > -1 ? "&" : "?";
        //modify source to autoplay and start video
        $(this).find("iframe")[0].src += symbol + "autoplay=1";
        // $(this).find("iframe").attr("autoplay", "1");

        $(this).parent().find(".playBtn").css("display", "none");
        $(this).parent().removeClass("click");
        }
    });
    //video with iframe
    //video with normal video tag
    $(".click.video").click(function () {
        if ($(this).hasClass("active")) {
        $(this).find("video")[0].pause();
        } else {
        console.log("tr");
        $(this).find("video")[0].play();
        }
    });
    $("video").on("pause", function () {
        $(this).parent().find(".playBtn").css("display", "flex");
        $($(this).parent().find("video")[0]).removeAttr("controls");
        $(this).parent().addClass("click");
    });

    $("video").on("play", function () {
        $(this).parent().find(".playBtn").css("display", "none");
        $(this).parent().removeClass("click");
        $($(this).parent().find("video")[0]).attr("controls", "controls");
    });
    //video with normal video tag
    //video click functionality


    //faq block
    $(".faq_block .question").click(function () {
        if ($(this).hasClass("current")) {
        $(this).removeClass("current");
        $(this).parent().find(".answer").slideUp();
        } else {
        // // $(".faq_block .question").removeClass("current");
        // var active = $(this).attr("data-active");
        // // console.log("active: ", active);

        // $(".dropdown_g .image_g .child").removeClass("active");
        // $(".dropdown_g .image_g ." + active).addClass("active");
        // $(".faq_block .answer").slideUp();
        $(this).addClass("current");
        $(this).parent().find(".answer").slideDown();
        }
    });
    //faq block
    //GENERAL LOGC FUNCTIONALITY//


    //PRODUCT PAGE//
    // //test 1
    // //my custom script - Function to rebuild both sliders based on selected colour
    // // --- Store original slides once ---
    // var $originalMainSlides = $(
    //     ".main_gallery .main_view_single_image .slider li"
    // ).clone(true, true);
    // var $originalThumbSlides = $(
    //     ".main_gallery .thumbnail_slider .thumbnail_slider_content .slider li"
    // ).clone(true, true);

    // // Function to rebuild both sliders based on selected colour
    // function updateSlidersByColour() {
    //     var selectedInput = $('.fieldset_colour input[type="radio"]:checked');
    //     if (!selectedInput.length) return;

    //     var selectedColour = selectedInput.val().trim().toLowerCase();
    //     console.log("Selected colour:", selectedColour);

    //     // --- MAIN SLIDER ---
    //     var $mainContainer = $(".main_gallery .main_view_single_image");
    //     var $mainSlider = $mainContainer.find(".slider");
    //     var $mainMatchedSlides = $originalMainSlides.filter(function () {
    //     var altText = $(this).find(".product__media img").attr("alt");
    //     return altText && altText.trim().toLowerCase() === selectedColour;
    //     });

    //     // --- THUMBNAIL SLIDER ---
    //     var $thumbContainer = $(
    //     ".main_gallery .thumbnail_slider .thumbnail_slider_content"
    //     );
    //     var $thumbSlider = $thumbContainer.find(".slider");
    //     var $thumbMatchedSlides = $originalThumbSlides.filter(function () {
    //     var altText = $(this).find("img").attr("alt");
    //     return altText && altText.trim().toLowerCase() === selectedColour;
    //     });

    //     // Destroy existing slick sliders if initialized
    //     if ($mainSlider.hasClass("slick-initialized")) $mainSlider.slick("unslick");
    //     if ($thumbSlider.hasClass("slick-initialized"))
    //     $thumbSlider.slick("unslick");

    //     // Remove old sliders
    //     $mainSlider.remove();
    //     $thumbSlider.remove();

    //     // Create new slider elements
    //     var $newMainSlider = $('<ul class="slider"></ul>');
    //     var $newThumbSlider = $('<ul class="slider"></ul>');

    //     // Append slides: use matched slides if found, else use all originals
    //     if ($mainMatchedSlides.length && $thumbMatchedSlides.length) {
    //     $mainMatchedSlides.clone(true, true).appendTo($newMainSlider);
    //     $thumbMatchedSlides.clone(true, true).appendTo($newThumbSlider);
    //     // console.log("✅ Sliders rebuilt for colour:", selectedColour);
    //     } else {
    //     // No match: show all original slides
    //     $originalMainSlides.clone(true, true).appendTo($newMainSlider);
    //     $originalThumbSlides.clone(true, true).appendTo($newThumbSlider);
    //     console.log("No matches found, showing all slides");
    //     }

    //     // Append new sliders into containers
    //     $mainContainer.append($newMainSlider);
    //     $thumbContainer.append($newThumbSlider);

    //     // Initialize Slick sliders again
    //     $newMainSlider.slick({
    //         infinite: false,
    //         autoplay: false,
    //         speed: 350,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         fade: true,
    //         arrows: true,
    //         touchMove: false,
    //         prevArrow: ".main_gallery .main_view_single_image .prev",
    //         nextArrow: ".main_gallery .main_view_single_image .next",
    //         asNavFor: ".main_gallery .thumbnail_slider .slider",
    //     });

    //     $newThumbSlider.slick({
    //         infinite: false,
    //         autoplay: false,
    //         speed: 350,
    //         slidesToShow: 5,
    //         slidesToScroll: 1,
    //         arrows: true,
    //         focusOnSelect: true,
    //         vertical: true,
    //         verticalSwiping: true,
    //         prevArrow: ".main_gallery .thumbnail_slider .prev",
    //         nextArrow: ".main_gallery .thumbnail_slider .next",
    //         asNavFor: ".main_gallery .main_view_single_image .slider",
    //     });
    //     enableZoomOnHover(2);
    // }
    // updateSlidersByColour();
    // //test 1


    //test 2
    if($("body").hasClass("temp_product")){
        // Store original slides once
        var $originalMainSlides = $(".main_gallery .main_view_single_image .slider li").clone(true, true);
        var $originalThumbSlides = $(".main_gallery .thumbnail_slider .thumbnail_slider_content .slider li").clone(true, true);
    
        // Function to rebuild or initialize sliders
        function updateSlidersByColour() {
            var $mainContainer = $(".main_gallery .main_view_single_image");
            var $thumbContainer = $(".main_gallery .thumbnail_slider .thumbnail_slider_content");
    
            var $mainSlider = $mainContainer.find(".slider");
            var $thumbSlider = $thumbContainer.find(".slider");
    
            // Destroy existing sliders if initialized
            if ($mainSlider.hasClass("slick-initialized")) $mainSlider.slick("unslick");
            if ($thumbSlider.hasClass("slick-initialized")) $thumbSlider.slick("unslick");
    
            // Remove old sliders
            $mainSlider.remove();
            $thumbSlider.remove();
    
            // Create new slider elements
            var $newMainSlider = $('<ul class="slider"></ul>');
            var $newThumbSlider = $('<ul class="slider"></ul>');
    
            var selectedInput = $('.fieldset_colour input[type="radio"]:checked');
            // colour options without swatch data render as pill buttons whose
            // fieldset lacks .fieldset_colour — fall back to the input name,
            // same selector the change listener below uses. "Style" covers
            // one-of-a-kind pieces (Color->Style rename, 2026-08-27).
            if (!selectedInput.length) {
                selectedInput = $('input[type="radio"][name^="Color-"]:checked, input[type="radio"][name^="Colour-"]:checked, input[type="radio"][name^="Style-"]:checked').first();
            }

            if (selectedInput.length) {
                // --- Product has colour variants ---
                var selectedColour = selectedInput.val().trim().toLowerCase();
                console.log("Selected colour:", selectedColour);

                // colour codes (e.g. "OWA") don't match image alt text directly;
                // the map (built in product-media-gallery-custom.liquid from each
                // variant's featured media) resolves colour -> media alt group
                var colourAltMap = {};
                var $mapEl = $(".main_gallery .colour_media_alt_map");
                if ($mapEl.length) {
                    try { colourAltMap = JSON.parse($mapEl.text()); } catch (e) {}
                }
                var mappedAlt = (colourAltMap[selectedColour] || "").trim().toLowerCase();
    
                //showing colour description if it exist
                var selectedColourDesc = CSS.escape(selectedInput.val().trim().toLowerCase().replace(/\s+/g, '_'));
                if($(".product__description .custom_color_desc." + selectedColourDesc).length){
                    $(".product__description .custom_color_desc").slideUp();
                    $(".product__description .defualt_desc").slideUp();
                    $(".product__description .custom_color_desc." + selectedColourDesc).slideDown();
                }else{
                    $(".product__description .custom_color_desc").slideUp();
                    $(".product__description .defualt_desc").slideDown();
                }
                //showing colour description if it exist
    
                var matchesSelectedColour = function (altText) {
                    if (!altText) return false;
                    altText = altText.trim().toLowerCase();
                    return altText === selectedColour || (mappedAlt && altText === mappedAlt);
                };

                var $mainMatchedSlides = $originalMainSlides.filter(function () {
                    return matchesSelectedColour($(this).find(".product__media img").attr("alt"));
                });

                var $thumbMatchedSlides = $originalThumbSlides.filter(function () {
                    return matchesSelectedColour($(this).find("img").attr("alt"));
                });
    
                if ($mainMatchedSlides.length && $thumbMatchedSlides.length) {
                    $mainMatchedSlides.clone(true, true).appendTo($newMainSlider);
                    $thumbMatchedSlides.clone(true, true).appendTo($newThumbSlider);
                } else {
                    console.log("No matches found, showing all slides");
                    $originalMainSlides.clone(true, true).appendTo($newMainSlider);
                    $originalThumbSlides.clone(true, true).appendTo($newThumbSlider);
                }
            } else {
                // --- Product has no colour variants ---
                console.log("No colour variant, showing all slides");
                $originalMainSlides.clone(true, true).appendTo($newMainSlider);
                $originalThumbSlides.clone(true, true).appendTo($newThumbSlider);
            }
    
            // Append new sliders into containers
            $mainContainer.append($newMainSlider);
            // $thumbContainer.append($newThumbSlider);
            if ($thumbContainer.children().length >= 1) {
                $thumbContainer.children().eq(0).after($newThumbSlider);
            } else {
                $thumbContainer.append($newThumbSlider); // fallback if container is empty
            }
    
            // Initialize Slick sliders
            $newMainSlider.slick({
                infinite: false,
                autoplay: false,
                speed: 350,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                arrows: true,
                touchMove: false,
                prevArrow: ".main_gallery .main_view_single_image .prev",
                nextArrow: ".main_gallery .main_view_single_image .next",
                asNavFor: ".main_gallery .thumbnail_slider .slider",
            });
    
            $newThumbSlider.slick({
                infinite: false,
                autoplay: false,
                speed: 350,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                focusOnSelect: true,
                vertical: true,
                verticalSwiping: true,
                prevArrow: ".main_gallery .thumbnail_slider .prev",
                nextArrow: ".main_gallery .thumbnail_slider .next",
                asNavFor: ".main_gallery .main_view_single_image .slider",
            });
    
            enableZoomOnHover(2);

            // 2026-09-22 (Dustin): slick measures the slider the instant it is
            // built. On mobile Safari the freshly-appended <ul> is not laid out
            // yet, so $list.width() comes back ~32px and slick writes that onto
            // every slide as an inline width. It never re-measures, so the
            // colourway shows as an empty 32x32 box for good. Re-measure once
            // layout settles, and again whenever a photo finishes decoding.
            var resyncSliders = function () {
                if ($newMainSlider.hasClass("slick-initialized")) {
                    $newMainSlider.slick("setPosition");
                }
                if ($newThumbSlider.hasClass("slick-initialized")) {
                    $newThumbSlider.slick("setPosition");
                }
            };
            requestAnimationFrame(function () {
                requestAnimationFrame(resyncSliders);
            });
            setTimeout(resyncSliders, 300);
            $newMainSlider.find("img").each(function () {
                if (!this.complete) {
                    $(this).one("load", resyncSliders);
                }
            });
        }
    
        // Call the function on page load
        updateSlidersByColour();
    
        //changin images when colour option changed
        $(document).on("change", 'input[name^="Color-"], input[name^="Colour-"], input[name^="Style-"]', function () {
            updateSlidersByColour();
        });
        //changin images when colour option changed
    }
    //test 2
    //PRODUCT PAGE//



    //CART PAGE//
    $('#custom_add_order_note').on('click', function () {
        const noteBox = $('.cart__note');

        if ($(this).hasClass('active')) {
            // If active → remove class + slide up
            $(this).removeClass('active');
            noteBox.slideUp();
        } else {
            // If not active → add class + slide down
            $(this).addClass('active');
            noteBox.slideDown();
        }
    });

    //changing continue shopping url 
    console.log("hee");
    const $body = $('body');
    const $continueBtn = $('.continue_shooping_block a');

    // 1. SET THE SESSION: Only if we are on a collection page
    if ($body.hasClass('temp_collection')) {
        sessionStorage.setItem('last_collection_path', window.location.pathname);
    } 
    // 2. CLEAR THE SESSION: If the page is NEITHER a collection NOR the cart
    else if (!$body.hasClass('temp_cart')) {
        sessionStorage.removeItem('last_collection_path');
    }

    // 3. UPDATE THE BUTTON: Apply logic if the button exists on the current page
    if ($continueBtn.length) {
        const lastVisited = sessionStorage.getItem('last_collection_path');
        
        if (lastVisited) {
        $continueBtn.attr('href', lastVisited);
        } else {
        // Fallback if session was cleared by another page
        $continueBtn.attr('href', '/collections/shop-all');
        }
    }
    //changing continue shopping url 
    //CART PAGE//




});